<template>
  <v-card
    outlined
    rounded="lg"
    height="100%"
    color="cardbg"
    class="flex"
    elevation="10"
  >
    <v-card-title
      color="primary"
      :style="`
        padding: calc(${scale} * 0.4rem) calc(${scale} * 0.4rem) 0 calc(${scale} * 0.4rem);
        line-height: calc(${scale} * 0.75rem);
        font-size: calc(${scale} * 0.7rem);`
      "
      class="font-weight-medium"
    >
      <div style="width: 33.33%; border-right: 1px solid #44474B;">
        Live
      </div>
      <div style="padding-left: 12px;">
        Rejection By Machine (NOS)
      </div>
    </v-card-title>
    <v-card-text
      :style="`padding: 0 calc(${scale} * 0.25rem);`"
      style="height: 89%; line-height: normal;"
    >
      <WidgetLoading v-if="loading" />
      <div
        :style="`
          height: 100%;
          font-size: calc(${scale} * 0.5rem);
        `"
        v-else
      >
        <v-row no-gutters class="h-full">
          <v-col
            cols="4"
            class="h-full"
            style="border-right: 1px solid #44474B;"
          >
            <v-row
              :style="`padding: calc(${scale} * 0.25rem); height: 50%;`"
              no-gutters
            >
              <v-col class="d-flex flex-column justify-center text-uppercase">
                <div
                  class="titlecolor--text"
                  :style="`font-size: calc(${scale} * 1.9rem); margin-bottom: 6%;`"
                >
                  {{ production.toLocaleString("en-IN") }}
                </div>
                <div>Production</div>
              </v-col>
              <v-col class="d-flex flex-column justify-center text-uppercase">
                <div
                  class="titlecolor--text"
                  :style="`font-size: calc(${scale} * 1.9rem); margin-bottom: 6%;`"
                >
                  {{ ppm.toLocaleString("en-IN") }}
                </div>
                <div>PPM</div>
              </v-col>
            </v-row>
            <v-row
              :style="`padding: calc(${scale} * 0.25rem); height: 50%;`"
              no-gutters
            >
              <v-col class="d-flex flex-column justify-center text-uppercase error--text">
                <div
                  :style="`font-size: calc(${scale} * 1.9rem); margin-bottom: 6%;`"
                >
                  {{ rejections.toLocaleString("en-IN") }}
                </div>
                <div>Rejection</div>
              </v-col>
              <v-col class="d-flex flex-column justify-center text-uppercase">
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="8" class="h-full">
            <highcharts
              :options="options"
              style="height: 100%; width: 100%;"
              :key="uuid"
            ></highcharts>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import WidgetLoading from '../WidgetLoading.vue';

export default {
  name: 'ProductionStatus',
  props: {
    scale: { type: Number, default: 1 },
  },
  components: { WidgetLoading },
  data() {
    return {
      uuid: 'sldfs',
      loading: false,
      production: 0,
      rejections: 0,
      machinenames: [],
      now: '',
      interval: null,
      options: {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, "Open Sans", sans-serif',
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            style: {
              fontFamily: 'Poppins, "Open Sans", sans-serif',
            },
            dataLabels: { enabled: true, style: { color: '#ffffff' } },
          },
        },
        title: {
          text: '',
          style: {
            fontFamily: 'Poppins, "Open Sans", sans-serif',
          },
        },
        xAxis: {
          categories: [],
          labels: { style: { color: '#FFFFFF' } },
          type: 'category',
          crosshair: true,
          title: { text: '' },
        },
        yAxis: {
          min: 0,
          minRange: 4,
          title: { text: '', style: { color: '#7AFC0B' } },
          labels: { style: { color: '#FFFFFF' } },
          gridLineColor: '#495767',
        },
        legend: { enabled: false },
        series: [{ name: 'Rejections', color: '#495364', data: [] }],
      },
    };
  },
  computed: {
    ...mapState('cellwiseQualityDashboard', [
      'theme', 'machines', 'serverTime', 'dataFromJSON', 'intervalfetch',
      'currentShift', 'currentDate', 'selectedCell',
    ]),
    ...mapGetters('cellwiseQualityDashboard', ['activeTheme', 'activeSite']),

    cellname() {
      return this.selectedCell || this.$route.query.selectedcell || '';
    },

    ppm() {
      return this.production ? Math.floor((this.rejections / this.production) * 1000000) : 0;
    },
  },
  watch: {
    scale(val) {
      this.adjustSize(val);
      this.createUUID();
    },
    cellname: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal && !this.dataFromJSON) {
          await this.fetchData(true);
        }
      },
    },
    async currentDate() {
      if (!this.dataFromJSON) await this.fetchData();
    },
    async currentShift() {
      if (!this.dataFromJSON) await this.fetchData();
    },
  },
  async mounted() {
    if (this.dataFromJSON) await this.dummydata();
    else {
      await this.fetchData(true);
      const refreshRate = (this.intervalfetch || 60) * 1000;
      this.interval = setInterval(async () => { await this.fetchData(); }, refreshRate);
    }
    this.createUUID();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions('cellwiseQualityDashboard', [
      'getMachines', 'getFileData', 'getReports',
    ]),

    async dummydata() {
      const res = await this.getFileData('jsondata/productionstatus.json');
      this.machinenames = res.machines;
      this.setProductionData(res);
      this.setOptions(res);
    },

    async fetchData(loader = false) {
      try {
        if (loader) this.loading = true;

        if (!this.machines || this.machines.length === 0) {
          await this.getMachines('?sortquery=sortindex==1');
        }

        const safeMachines = Array.isArray(this.machines) ? this.machines : [];
        let filteredMachines = safeMachines;
        if (this.cellname) {
          filteredMachines = safeMachines.filter((m) => m.machinecell === this.cellname);
        }
        this.machinenames = filteredMachines.map((m) => m.machinename).sort();

        if (!this.currentDate || !this.currentShift) {
          this.loading = false;
          return;
        }

        let siteId = this.activeSite
         || this.$store.state.user?.activeSite || this.$store.state.auth?.user?.site_id;
        if (!siteId) {
          try {
            const swxUser = JSON.parse(localStorage.getItem('user') || '{}');
            siteId = swxUser?.site_id || swxUser?.site?.id || swxUser?.customer?.site_id;
          } catch (e) { /* ignore */ }
        }

        const payload = {
          siteid: siteId || 0,
          dateVal: parseInt(this.currentDate, 10),
          shiftVal: this.currentShift,
          all: true,
        };

        if (this.cellname) {
          payload.machinecell = this.cellname;
        }

        const rawResponse = await this.getReports({ reportName: 'shiftliveshopfloor', payload });
        const apiResponse = typeof rawResponse === 'string' ? JSON.parse(rawResponse) : rawResponse;

        let recordsArray = [];
        let finalData = apiResponse.reportData ? apiResponse.reportData : apiResponse;
        if (typeof finalData === 'string' && finalData !== '') {
          finalData = JSON.parse(finalData);
        }

        if (finalData && finalData.machines) {
          recordsArray = finalData.machines;
        }

        this.setProductionData(recordsArray);
        this.setOptions(recordsArray);
      } catch (e) {
        console.error('[ProductionStatus] Hydration Error:', e);
      } finally {
        this.loading = false;
      }
    },

    setProductionData(machinesArray) {
      let production = 0;
      let rejectionquantity = 0;

      machinesArray.forEach((d) => {
        const dbCellName = d.machinecell || d.cell || d.cellname;
        if (!this.cellname || this.cellname === dbCellName) {
          let mQty = 0;
          let mRejection = 0;

          if (d.production && d.production.length > 0) {
            mQty = d.production.reduce((sum, p) => sum + (Number(p.produced) || 0), 0);
            mRejection = d.production.reduce((sum, p) => sum + (Number(p.rejected) || 0), 0);
          } else {
            mQty = Number(d.qty) || Number(d.actualquantity) || Number(d.produced) || 0;

            mRejection = Number(d.rqty) || Number(d.rejectionquantity) || Number(d.rejected) || 0;

            const rPct = Number(d.rejectionpercent) || 0;
            if (mRejection === 0 && rPct > 0) {
              mRejection = Math.round((mQty * rPct) / 100);
            }
          }

          production += mQty;
          rejectionquantity += mRejection;
        }
      });

      this.production = production;
      this.rejections = rejectionquantity;
    },

    setOptions(machinesArray) {
      const categories = [];
      const seriesData = [];

      const apiMap = new Map();
      machinesArray.forEach((d) => {
        const mName = (d.machinename || d.machineName || d.name || '').trim();
        let mRejections = 0;

        if (d.production && d.production.length > 0) {
          mRejections = d.production.reduce((sum, p) => sum + (Number(p.rejected) || 0), 0);
        } else {
          mRejections = Number(d.rqty) || Number(d.rejectionquantity) || Number(d.rejected) || 0;
          const mQty = Number(d.qty) || Number(d.actualquantity) || Number(d.produced) || 0;
          const rPct = Number(d.rejectionpercent) || 0;
          if (mRejections === 0 && rPct > 0) {
            mRejections = Math.round((mQty * rPct) / 100);
          }
        }
        apiMap.set(mName, mRejections);
      });

      // 2. Build series based on the machine list
      this.machinenames.forEach((machine) => {
        const cleanMachine = machine.trim();
        categories.push(cleanMachine);

        // Lookup in our map
        const val = apiMap.get(cleanMachine) || 0;
        seriesData.push({ color: '#495364', y: val });
      });

      this.assignData({ categories, series: [{ name: 'Rejections', data: seriesData }] });
    },

    assignData(result) {
      this.options.xAxis.categories = result.categories;
      this.options.series = result.series;
      this.adjustSize(this.scale);
      this.createUUID();
    },

    adjustSize(scale) {
      const lablesize = 9 * scale;
      const padding = 15 * scale;
      const currentTheme = this.activeTheme || 'dark';

      let subtitleColor = '#A1A3A5';
      if (this.theme && this.theme.themes && this.theme.themes[currentTheme]) {
        subtitleColor = this.theme.themes[currentTheme].subtitlecolor;
      }

      const style = {
        color: subtitleColor,
        fontSize: lablesize,
        fontFamily: 'Poppins, "Open Sans", sans-serif',
      };

      if (!this.options.xAxis.labels) this.options.xAxis.labels = {};
      this.options.xAxis.labels.style = style;
      this.options.xAxis.labels.reserveSpace = true;
      this.options.xAxis.labels.y = padding;

      if (!this.options.yAxis.labels) this.options.yAxis.labels = {};
      this.options.yAxis.labels.style = style;

      if (!this.options.plotOptions.series.dataLabels) {
        this.options.plotOptions.series.dataLabels = {};
      }
      this.options.plotOptions.series.dataLabels.style = {
        fontSize: lablesize,
        color: '#ffffff',
        textOutline: 'none',
        fontFamily: 'Poppins, "Open Sans", sans-serif',
      };
    },

    createUUID() {
      this.uuid = `uuid-${Math.random().toString(36).substr(2, 9)}`;
    },
  },
};
</script>
